<template>
    <div class="modal-box">
        <div class="modal-box-inner" v-loading="loading">
            <div class="modal-box-header" v-if="this.header">
                <span class="modal-box-header-title">
                    email
                </span>
                <a class="modal-box-header-back" @click.prevent="close()">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14"><defs><clipPath id="clip-path"><rect width="14" height="14" fill="none"/></clipPath></defs><g id="Icon_-_Close" data-name="Icon - Close" clip-path="url(#clip-path)"><path id="ic_close_24px" d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z" transform="translate(-5 -5)" fill="#444"/></g></svg>
                </a>
            </div>
            <span class="modal-box-header-inner mobile-hide">
                email
            </span>

            <div class="modal-box-content asset-share">
              <el-form ref="form" :rules="rules" :model="form" @submit.prevent.native="formSubmit('form')">
                <el-form-item prop="email">
                  <el-input ref="email" v-model="form.email" placeholder="email"></el-input>
                </el-form-item>

                <div class="modal-box-actions">
                  <button native-type="submit" type="primary" class="modal-box-actions-item button">add email
                  </button>
                </div>

                <div class="asset-share-autocomplete-selected">
                  <p v-for="(email, index) in emails" :key="'email_' + index">
                    {{email}} <button @click.prevent.stop="removeEmail(index)"></button>
                  </p>
                </div>
              </el-form>

              <div class="modal-box-actions end">
                <button  @click.prevent.stop="share()" type="primary" class="modal-box-actions-item button">Share</button>
                <button @click.prevent="close" type="text" class="modal-box-actions-item button white">Cancel</button>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { HTTP } from '@/services/api'

import { HTTP } from '@/services/api'

export default {
  props: {
    header: {
      type: [Boolean, Object]
    },
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  name: 'PublicAssetShareModal',
  data () {
    return {
      loading: false,
      form: {
        email: ''
      },
      emails: [],
      rules: {
        email: [
          { required: true, message: 'Please enter email', trigger: 'focus' },
          { type: 'email', message: 'You have to enter valid email', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.close()
      }
    })
  },
  methods: {
    share () {
      if (this.emails.length === 0) {
        return this.$notify({
          message: 'Please add emails',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
      }

      let data = {}
      data.ids = this.data.ids
      data.emails = this.emails
      if (this.data.ids.length === 1) {
        data.filename = this.data.filenames[0]
      }

      this.loading = true
      HTTP({
        method: 'POST',
        url: '/api/v1/assets/public-share/',
        crossdomain: true,
        data: data
      }).then(() => {
        this.loading = false
        this.$notify({
          message: 'Email sending initiated',
          type: 'success',
          position: 'bottom-right',
          duration: 1750
        })
        this.close()
      }).catch(() => {
        this.$notify({
          message: 'Email sending initiation failed, please try again',
          type: 'error',
          position: 'bottom-right',
          duration: 1750
        })
        this.loading = false
      })
    },
    formSubmit (formName) {
      let self = this
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let index = self.emails.findIndex(function (item) { return item === self.form.email })
          if (index === -1) {
            self.emails.push(self.form.email)
          }
          self.form.email = ''
          return true
        }

        return false
      })
    },
    removeEmail (index) {
      this.emails.splice(index, 1)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>
